module.exports = __webpack_public_path__ + "img/juggernaut_alt1.d93fe85e.png";